import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import {Container} from "@mui/material";
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';


const About = () => {

    //const token = localStorage.getItem('token');

    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();

    const open = Boolean(anchorEl);

    const isAdmin = localStorage.getItem('x') === "1";

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleMenuClose = () => {
        setAnchorEl(null);
    }

    const handleMenuLogout = () => {
        handleMenuClose();
        localStorage.setItem('token', "");
        localStorage.setItem('email', "");
        localStorage.setItem('x', "");
        navigate('/');
    }

    const handleMenuSearch = () => {
        handleMenuClose();
        navigate('/landing')
    }

    const handleMenuProfile = () => {
        handleMenuClose();
        navigate('/profile')
    }

    const handleMenuAdvancedSearch= () => {
        handleMenuClose();
        navigate('/advancedSearch')
    }

    const handleMenuUserManagement= () => {
        handleMenuClose();
        navigate('/userManagement')
    }

    useEffect(() => {

    }, []);
    return (
        <Container component="main" maxWidth="lg">
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                            aria-haspopup="true"
                            aria-controls={open ? 'popup-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleMenuClick}
                        >
                            <MenuIcon />
                        </IconButton>
                        {/* The actual MUI Menu component */}
                        <Menu
                            id="popup-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleMenuClose}
                            // Keep the menu mounted in the DOM when closed for potential performance benefits
                            // You can remove keepMounted if you prefer it to unmount
                            keepMounted
                            MenuListProps={{
                                'aria-labelledby': 'menu-button',
                            }}
                        >
                            {/* Menu Items */}
                            <MenuItem onClick={handleMenuSearch}>
                                <Typography variant="inherit">Search</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleMenuProfile}>
                                <Typography variant="inherit">Profile</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleMenuAdvancedSearch}>
                                <Typography variant="inherit">Advanced Search</Typography>
                            </MenuItem>
                            {isAdmin && <MenuItem onClick={handleMenuUserManagement}><Typography variant="inherit">User Management</Typography></MenuItem>}
                            <MenuItem onClick={handleMenuLogout}>
                                <Typography variant="inherit">Logout</Typography>
                            </MenuItem>
                        </Menu>

                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            About
                        </Typography>
                    </Toolbar>
                </AppBar>
            </Box>
            <Paper sx={{ padding: '20px'}}>
                <Typography variant="h6">
                    Overview
                </Typography>
                <br/>
                <Typography variant="body1">
                    This application is used to present lists of films that have been nominated in all categories for the Academy
                    Awards, Sundance and Cannes film festivals.  At launch, this data is available for years going back to 1999.
                    On the primary search screen, lists of nominees can be searched by year and festival.  In addition, once a film
                    has been seen, it can be associated with a date indicating when it was seen.  The basic search function includes
                    a dropdown that allows the user to select whether the movie list includes all movies for that year, movies that have
                    been seen, or movies that have yet to be seen.
                </Typography>
                <br/>
                <Typography variant="body1">
                    Movies in the list include columns that indicate the year, title, director's name, genre, run length,
                    number of nominations and number of award wins.  The lists can be sorted by column by mousing down on
                    column header.  Note that only 10 films will be represented in the list, but additional films may be
                    viewed by selecting the pagination indicators at the bottom of the list. By selecting an entry in
                    this list, additional fields are populated at the bottom of the page that include the movie poster,
                    the names of the categories for which the film has been nominated, the names of the categories for
                    which the film won the award, a synopsis, the rotten tomatoes rating, the IMDB rating and a calendar
                    field for which the user can set date on which the film was seen.
                </Typography>
                <br/>
                <Typography variant="h6">
                    Advanced Search
                </Typography>
                <br/>
                <Typography variant="body1">
                    In addition to the basic search functionality described above, you can select the Advanced Search capability
                    accessible through the Hamburger menu within the title bar on the top left of the entry page.  On the Advanced
                    Search page, you can search for movies by inputting a portion of a movie name, director's name, select a
                    genre, input a running time range and a history setting that allows presenting all movies or just
                    those you've seen or haven't seen that match the search criteria.  In inputting the movie name and/or the
                    director's name, you just need to input a portion of the search text. When you activate the SEARCH button
                    you will see all of the matching films in full.  For example, if you enter "barb" (without the quotes) in the movie name,
                    and activate the SEARCH button, you will get a list of at least 10 films along with the year they were
                    released and which festival they were nominated for as well as the fields that are presented on the Basic
                    Search page.  One of the entries is "Barbie" that was nominated at the Academy Awards in 2024.  The remaining
                    functionality on this page is similar to that of the Basic Search page.  One advantage in using the Advanced
                    Search page is that you can identify all of the films that a particular director has released that
                    have been nominated in all of the festivals over time.
                </Typography>
                <br/>
                <Typography variant="h6">
                    Roadmap
                </Typography>
                <br/>
                <Typography variant="body1">
                    In the future, our intention is to extend the application to include a greater date range,
                    additional film festivals, more complex search functionality such as searching by actor
                    and the option to add films that were not nominated but have been recommended by users.
                    Suggestions for future functionality are welcomed, and may be made by sending email to the
                    site administrator at: tlillie@omix.com.
                </Typography>
                <br/>
                <Typography variant="h6">
                    Where can I see the films that I'm interested in?
                </Typography>
                <br/>
                <Typography variant="body1">
                    Anyone that has accessed a streaming service knows that the content for each service changes over time.  Films
                    and Shows are continuously rotated through these services. You can search each service for a particular film, but
                    this quickly becomes very cumbersome and time consuming.
                </Typography>
                <br/>
                <Typography variant="body1">
                    Alternatively, one of the best ways to discover where you might go to see a film that you are interested in viewing is to
                    visit <Link href="https://plex.tv" target="_blank" rel="noopener">Plex TV</Link>.  You can optionally choose to create a free account to personalize your
                    access to their service, but it's not necessary.  Once you access their entry page, you will see a search bar
                    in the upper left corner.  By entering the name of the film in this search region, you will see a drop down list of
                    of the matching movies, including the year the film was released.  By selecting a film from this list, you will be
                    presented with a detail page that ofter contains a "Watch from these locations" region.  Because streaming service content
                    is so dynamic, the list you see here may not reflect the latest changes, but it beats searching each service individually.
                    These days, you can also Google the movie by name and often see up to date entries (with the exception of Library Services),
                    indicating where the movie of interest can be seen.
                </Typography>
                <br/>
                <Typography variant="h6">
                    Library Services
                </Typography>
                <br/>
                <Typography variant="body1">
                    In addition to the many streaming services, your local library may give you access to a service that they support.  Two such
                    services are Kanopy (30,000 films) and Hoopla Digital.  To gain access, you just need to apply for a library card.
                </Typography>
                <br/>
                <Typography variant="body1">
                    Those that have access to an academic environment might have access to: Swank Digital Campus, Projectr, and Docuseek.
                </Typography>
                <br/>
                <Typography variant="h6">
                    Application Release: 1.0.3
                </Typography>
            </Paper>
        </Container>

    );
};

export default About;